export default __webpack_public_path__ + "static/Hack-ZeroSlash-Bold-c8ea19a8461596cf1a6a2ad08bebcf8e.woff";